import { useEffect } from "react";
import confetti from "canvas-confetti";

const fireMoney = () => {
  try {
    const gold = ["#F59E0B", "#f2c230", "#10B981", "#ffffff"];
    confetti({ particleCount: 80, spread: 70, startVelocity: 45, origin: { y: 0.4 }, colors: gold, scalar: 1.2, zIndex: 100000 });
    setTimeout(() => confetti({ particleCount: 50, angle: 60, spread: 60, origin: { x: 0, y: 0.5 }, colors: gold, zIndex: 100000 }), 120);
    setTimeout(() => confetti({ particleCount: 50, angle: 120, spread: 60, origin: { x: 1, y: 0.5 }, colors: gold, zIndex: 100000 }), 120);
  } catch (e) { /* no-op */ }
};

// signing = { name, player, rating } | null
const SigningPopup = ({ signing, onDone }) => {
  useEffect(() => {
    if (!signing) return;
    fireMoney();
    const t = setTimeout(() => onDone && onDone(), 2600);
    return () => clearTimeout(t);
  }, [signing, onDone]);

  if (!signing) return null;

  return (
    <div className="fixed inset-x-0 top-20 z-[9999] flex justify-center px-4 pointer-events-none" data-testid="signing-popup">
      <div className="signing-pop rounded-2xl border border-[#F59E0B]/50 bg-[#1E293B]/95 backdrop-blur-sm px-5 py-3 shadow-2xl flex items-center gap-3 max-w-sm">
        <span className="text-3xl animate-bounce">💰</span>
        <div className="min-w-0">
          <div className="text-sm text-slate-200 truncate">
            <span className="font-bold text-white">{signing.name}</span> just signed
          </div>
          <div className="font-display font-extrabold text-lg leading-tight truncate">
            <span className="text-[#F59E0B]">{signing.player}</span>
            <span className="text-[#10B981] text-sm font-bold ml-2">OVR {signing.rating}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SigningPopup;
